import { type FillStartEvent } from '../events/types';
import { type SelectionState } from '../state/types';

import { type ReducerResponse } from './types';

/**
 * Starts a fill interaction from the active selection range and emits the range
 * for rendering effects. A fill cannot start without an existing range.
 */
export function fillStartReducer(
  state: SelectionState,
  event: FillStartEvent
): ReducerResponse {
  const sourceRange = state.selections[state.selections.length - 1];

  if (!sourceRange) {
    return { next: state, delta: { kind: 'noop' } };
  }

  return {
    next: {
      ...state,
      lastInteractionSource: event.source
    },
    delta: {
      kind: 'fillStarted',
      source: event.source,
      sourceRange
    }
  };
}
